module.exports = __webpack_public_path__ + "img/icon_aside_ppt5_active.7fd33d62.svg";